import { v4 as uuidv4 } from "uuid";
import config from "../config";
const root = config.REACT_APP_API_URL;

const _createCampaign = async (brandName, campaignName, body, jwt) => {
  return await new Promise(async (resolve, reject) => {
    fetch(root + `api/campaign/${brandName}/${campaignName}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const _uploadImage = (file) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    const fileName = uuidv4();
    formData.append("image", file);
    //formData.append('image-name', 'img-upload');

    fetch(root + `api/file/upload`, {
      method: "POST",
      headers: {
        "file-name": fileName,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        const filePath = `/api/file/${fileName}`;
        //onUpload(filePath);
        //setImg(filePath);
        resolve(filePath);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const _createCampaignBuckets = async (brandName, campaignName, body, jwt) => {
  return await new Promise(async (resolve, reject) => {
    fetch(root + `api/campaign/${brandName}/${campaignName}/buckets`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt,
      },
      body: JSON.stringify(body),
    })
      //.then((response) => response.json())
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const editBrandCampaign = async (brand, campaign) => {
  try {
    const jwt = localStorage.getItem("jwtToken");
    if (!jwt) return;
    const jwtPayload = JSON.parse(atob(jwt.split("Bearer ")[1].split(".")[1]));
    if (!jwtPayload.isAdmin) {
      return;
    }
    const brandName = brand;

    let coverUrl = campaign.cover;
    if (typeof campaign.cover == "object") {
      coverUrl = await _uploadImage(campaign.cover);
    }

    const body = {
      id: campaign.id,
      archived: campaign.archived || false,
      name: campaign.name,
      cover: coverUrl,
      description: campaign.description,
      medium: campaign.medium,
      genre: campaign.genre,
      home: campaign.home,
    };
    
    let themeImages = []
    let socialImages = []
    let castImages = []
    let influencerImages = []
    if(campaign.buckets && Object.keys(campaign.buckets[0]).length){
      castImages = await Promise.all(
        campaign.buckets[0].castLinks?.map(async (img) => {
          if(typeof img === "object"){
            return await _uploadImage(img)
          }
          return img
        })
      );
      themeImages = await Promise.all(
        campaign.buckets[0].themeLinks?.map(async (img) => {
          if(typeof img === "object"){
            return await _uploadImage(img)
          }
          return img
        })
      );
      if(campaign.buckets[0].socialLinks?.length){
        socialImages = await Promise.all(
          campaign.buckets[0].socialLinks?.map(async (img) => {
            if(typeof img === "object"){
              return await _uploadImage(img)
            }
            return img
          })
        );
      }
      influencerImages = await Promise.all(
        campaign.buckets[0].influencerLinks?.map(async (img) => {
          if(typeof img === "object"){
            return await _uploadImage(img)
          }
          return img
        })
      );
    }

    await _createCampaign(brandName, campaign.name, body, jwt);

    if (campaign.buckets && Object.keys(campaign.buckets[0]).length) {
      await _createCampaignBuckets(
        brandName,
        campaign.name,
        {
        buckets: [
          {
            messageTaglines: campaign.buckets[0].messageTaglines || [],
            conceptStorylines: campaign.buckets[0].conceptStorylines || [],
            castLinks: castImages || [],
            themeLinks: themeImages || [],
            socialLinks: socialImages || [],
            influencerLinks: influencerImages || [],
          },
        ],
        },
        jwt
      );
    }
  } catch (err) {
    throw err;
  }
};

export const createBrandCampaign = async (campaign) => {
  try {
    const jwt = localStorage.getItem("jwtToken");
    if (!jwt) return;
    const jwtPayload = JSON.parse(atob(jwt.split("Bearer ")[1].split(".")[1]));
    const brandName = jwtPayload.organization;

    const body = {
      cover: await _uploadImage(campaign.cover),
      description: campaign.description,
      medium: campaign.medium,
      genre: campaign.genre,
      home: campaign.home,
    };

    const buckets = { buckets: campaign.buckets };

    await _createCampaign(brandName, campaign.name, body, jwt);

    const castImages = await Promise.all(
      campaign.castImages.map(async (img) => await _uploadImage(img))
    );
    const themeImages = await Promise.all(
      campaign.themeImages.map(async (img) => await _uploadImage(img))
    );
    const socialImages = await Promise.all(
      campaign.socialImages.map(async (img) => await _uploadImage(img))
    );
    const influencerImages = await Promise.all(
      campaign.influencerImages.map(async (img) => await _uploadImage(img))
    );

    await _createCampaignBuckets(
      brandName,
      campaign.name,
      {
        buckets: [
          {
            messageTaglines: campaign.messageTaglines,
            conceptStorylines: campaign.conceptStorylines,
            castLinks: castImages,
            themeLinks: themeImages,
            socialLinks: socialImages,
            influencerLinks: influencerImages,
          },
        ],
      },
      jwt
    );
  } catch (err) {
    throw err;
  }
};

export const getBrandCampaigns = (brand) => {
  return new Promise((resolve, reject) => {
    fetch(root + `api/campaign/${brand}`)
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBrandCampaign = (brand, campaign) => {
  return new Promise((resolve, reject) => {
    fetch(root + `api/campaign/${brand}/${campaign}`)
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllCampaigns = () => {
  const jwt = localStorage.getItem("jwtToken");

  return new Promise((resolve, reject) => {
    fetch(root + `api/campaign`, {
      method: "GET",
      headers: {
        Authorization: jwt,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const submitBrandCampaign = async (campaign) => {
  return new Promise((resolve, reject) => {
    try {
      const jwt = localStorage.getItem("jwtToken");
      if (!jwt) return;
      const jwtPayload = JSON.parse(
        atob(jwt.split("Bearer ")[1].split(".")[1])
      );

      const body = {
        username: jwtPayload.email,
        brand: campaign.brand,
        campaign: campaign.campaign,
        messageTagline: campaign.messageTaglines,
        themeLink: campaign.themeLinks,
        castLink: campaign.castLinks,
        socialLink: campaign.socialLinks,
        influencerLink: campaign.influencerLinks,
      };

      fetch(root + `api/campaign/evaluation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + jwt,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            resolve(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      throw err;
    }
  });
};
